import { render, staticRenderFns } from "./back-to-top.vue?vue&type=template&id=2e3b2a82&scoped=true"
import script from "./back-to-top.vue?vue&type=script&lang=js"
export * from "./back-to-top.vue?vue&type=script&lang=js"
import style0 from "./back-to-top.vue?vue&type=style&index=0&id=2e3b2a82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b2a82",
  null
  
)

export default component.exports